import Cookies from 'js-cookie';
import {INSTALL_ID_COOKIE_NAME, SKILLZ_APP_COOKIE_NAME, PARTNER_COOKIE_NAME} from '@/utils/constant';
import {getEnvConfig} from '@/utils/getEnvConfig';

export default class AppsFlyerUtils {
  /**
   * Partner white-label attribution: the resolved partner slug (set host-only by
   * middleware) is stamped onto every PBA event so signup / install / deposit /
   * NGR attribute to the partner independent of AppsFlyer's first-touch media
   * source. Returns undefined when there's no partner context.
   */
  private static getPartner(): string | undefined {
    return Cookies.get(PARTNER_COOKIE_NAME) || undefined;
  }

  static sendIdentityLink(): void {
    const userId = Cookies.get(getEnvConfig().CURRENT_USER_COOKIE_NAME);
    if (typeof window !== 'undefined' && window.AF) {
      window.AF('pba', 'setCustomerUserId', userId);
      const partner = AppsFlyerUtils.getPartner();
      if (partner) {
        // Carry the partner as PBA additional data so it rides along with the CUID.
        window.AF('pba', 'setAdditionalData', {partner});
      }
    }
  }

  static trackWebSDKInstallEvent(webInstallId, gameId): void {
    if (typeof window !== 'undefined' && window.AF) {
      const userId = Cookies.get(getEnvConfig().CURRENT_USER_COOKIE_NAME);
      const skillzApp = Cookies.get(SKILLZ_APP_COOKIE_NAME) === '1' ? true : false;
      const eventValue = {webInstallId, gameId};
      if (userId) {
        eventValue['userId'] = userId;
      }
      const partner = AppsFlyerUtils.getPartner();
      if (partner) {
        eventValue['partner'] = partner;
      }
      window.AF('pba', 'event', {
        eventType: 'EVENT',
        eventValue: eventValue,
        eventName: skillzApp ? 'skillz_app_web_first_launch' : 'web_sdk_install',
      });
    } else {
      console.warn('AppsFlyer SDK is not initialized yet');
    }
  }

  static trackGameInstallEvent(gameInstallId, gameId): void {
    if (typeof window !== 'undefined' && window.AF) {
      const userId = Cookies.get(getEnvConfig().CURRENT_USER_COOKIE_NAME);
      const skillzApp = Cookies.get(SKILLZ_APP_COOKIE_NAME) === '1' ? true : false;
      const eventValue = {gameInstallId, gameId};
      if (userId) {
        eventValue['userId'] = userId;
      }

      const installId = Cookies.get(INSTALL_ID_COOKIE_NAME);
      if (installId) {
        eventValue['webInstallId'] = installId;
      }
      const partner = AppsFlyerUtils.getPartner();
      if (partner) {
        eventValue['partner'] = partner;
      }
      window.AF('pba', 'event', {
        eventType: 'EVENT',
        eventValue: eventValue,
        eventName: skillzApp ? 'skillz_app_game_first_launch' : 'web_game_install',
      });
    } else {
      console.warn('AppsFlyer SDK is not initialized yet');
    }
  }

  static trackDepositEvent(eventValue, currency, gameId): void {
    if (typeof window !== 'undefined' && window.AF) {
      const userId = Cookies.get(getEnvConfig().CURRENT_USER_COOKIE_NAME);
      const skillzApp = Cookies.get(SKILLZ_APP_COOKIE_NAME) === '1' ? true : false;
      const depositEventValue: Record<string, unknown> = {
        af_revenue: eventValue,
        af_currency: currency,
        gameId,
        userId,
      };
      const partner = AppsFlyerUtils.getPartner();
      if (partner) {
        depositEventValue['partner'] = partner;
      }
      window.AF('pba', 'event', {
        eventType: 'EVENT',
        eventValue: depositEventValue,
        eventName: skillzApp ? 'skillz_app_web_deposit' : 'deposit',
      });
    } else {
      console.warn('AppsFlyer SDK is not initialized yet.');
    }
  }
}
